import React from 'react';
import { CopyLinkActionProps, CopyLinkActionType } from '../../types';
import { CopySavedViewLinkAction } from './CopySavedViewLinkAction';
import { registerCommonActionsMenuItem } from '../../../components/CommonActionsMenu';

export type CopySavedViewLinkItemProps<TViewState extends object> = Omit<CopyLinkActionProps<TViewState>, 'actionType'>;

export function CopySavedViewLinkMenuItem<TViewState extends object>(
  props: CopySavedViewLinkItemProps<TViewState>
): JSX.Element {
  return <CopySavedViewLinkAction {...props} actionType={CopyLinkActionType.MenuItem} />;
}

registerCommonActionsMenuItem(CopySavedViewLinkMenuItem, 3);
